<div class="background">
	<div class="">
		<div class="col-sm" >
		</div>
		<div class="container py-2">
			<h2 class="font-weight-light text-center  py-3">Timeline</h2>
			<div class="row g-0" *ngFor="let timeline of timelines; let i = index">
				<div class="row g-0" *ngIf="i % 2 === 0">
					<div class="col-sm">
						<!--spacer-->
					</div>
					<div class="col-sm-1 text-center flex-column d-none d-sm-flex">
						<div class="row h-50">
							<div class="col border-end">&nbsp;</div>
							<div class="col">&nbsp;</div>
						</div>
						<h5 class="m-2">
						<span class="badge rounded-pill bg-primary">&nbsp;</span>
					</h5>
						<div class="row h-50">
							<div class="col border-end">&nbsp;</div>
							<div class="col">&nbsp;</div>
						</div>
					</div>
					<div class="col-sm py-2">
						<div class="card radius-15">
							<div class="card-body">
								<div class="float-end text-primary">{{timeline.start}}</div>
									<h4 class="card-title text-primary">{{timeline.title.name}}</h4>
									<p class="card-text">{{timeline.label}}</p>
							</div>
						</div>
					</div>
				</div>
				<div class="row g-0"  *ngIf="i % 2 !== 0">
					<div class="col-sm py-2">
						<div class="card border-primary shadow radius-15">
							<div class="card-body">
								<div class="float-end text-primary">{{timeline.start}}</div>
									<h4 class="card-title text-primary">{{timeline.title.name}}</h4>
									<p class="card-text">{{timeline.label}}</p>
							</div>
						</div>
					</div>
					<div class="col-sm-1 text-center flex-column d-none d-sm-flex">
						<div class="row h-50">
							<div class="col border-end">&nbsp;</div>
							<div class="col">&nbsp;</div>
						</div>
						<h5 class="m-2">
						<span class="badge rounded-pill bg-primary">&nbsp;</span>
					</h5>
						<div class="row h-50">
							<div class="col border-end">&nbsp;</div>
							<div class="col">&nbsp;</div>
						</div>
					</div>
					<div class="col-sm">
						<!--spacer-->
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
